import { CopyButton } from "./shared";

const fmt = (iso) =>
  new Date(iso).toLocaleString("es-ES", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

export function TranslatorHistory({ messages }) {
  return (
    <div className="border-2 border-black bg-white" data-testid="translator-history">
      <div className="px-4 py-3 border-b-2 border-black font-display font-bold text-sm">
        Historial ({messages.length})
      </div>
      <div className="p-4 space-y-3 max-h-[480px] overflow-y-auto">
        {messages.length === 0 && <p className="text-xs text-zinc-500">Aún no hay mensajes.</p>}
        {messages.map((m) => {
          const incoming = m.direction === "in";
          return (
            <div key={m.id} className={`flex ${incoming ? "justify-start" : "justify-end"}`} data-testid={`translator-msg-${m.id}`}>
              <div className={`max-w-[85%] p-3 border ${incoming ? "border-black bg-zinc-50" : "border-[#E63946] bg-[#E63946]/5"}`}>
                <div className="text-[10px] uppercase tracking-widest text-zinc-500 mb-1">
                  {incoming ? "Cliente" : "Nosotros"} · {m.source_lang} → {m.target_lang} · {fmt(m.created_at)}
                </div>
                <p className="text-sm whitespace-pre-wrap">{incoming ? m.translated_text : m.original_text}</p>
                <p className="text-xs text-zinc-500 italic mt-1 whitespace-pre-wrap">{incoming ? m.original_text : m.translated_text}</p>
                {!incoming && <div className="mt-2"><CopyButton text={m.translated_text} testId={`translator-msg-copy-${m.id}`} /></div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
